angular.module('impactx.companyhierarchy').controller('CompanyHierarchyCtrl', [
    'dataGen',
    'ToolbarService',
    '$timeout',
    '$redirect',
    CompanyHierarchyController
]);

function CompanyHierarchyController(dataGen, ToolbarService, $timeout, $redirect) {
    var self = this;
    self.requestInProgress = false;
    self.breadcrumbs = [{comId: 0, label: 'Root', type: 'COMPANY'}];
    self.selectedNode = {};
    ToolbarService.setButtons([]);

    getRootNodes();

    self.toggleCompanyAttribute = function (attribute) {
        attribute.value = !attribute.value;

        getRootNodes(self.data);
    }

    self.toggle = function (event, entry, open, overflowMarker) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (overflowMarker) {
            return;
        }
        var foundEntryInTree = findEntry(entry);
        if (foundEntryInTree) {
            entry = foundEntryInTree;
        }

        if (open) {
            entry.isOpen = true;
        }
        else {
            entry.isOpen = !entry.isOpen;
        }

        if (entry.isOpen && !entry.entries) {
            getSubNodes(entry).then(function (data) {
                var newEntries = impactX.isDefined(data, 'data.entries');
                if (newEntries) {
                    applyItemList(newEntries, entry);
                    self.selectedNode = entry;
                }
            });
        }
        else {
            if (!entry.isOpen && entry.entries && !entry.isFolder) {
                //has just been closed -> build sub bread bread crumb and set super node as selected
                self.selectedNode = entry;
                setSelectedNode(self.selectedNode);
                var newBreadCrumb = [];
                for (let i = 0; i < self.breadcrumbs.length; i++) {
                    if (self.breadcrumbs[i].id === entry.id &&
                        self.breadcrumbs[i].type === entry.type) {
                        break;
                    }
                    newBreadCrumb.push(self.breadcrumbs[i]);
                }
                self.breadcrumbs = newBreadCrumb;
                self.selectedNode = newBreadCrumb[newBreadCrumb.length - 1];
            }
            else {
                self.selectedNode = entry;
                setSelectedNode(self.selectedNode);
            }
        }
    };

    function findEntry(entry, compareEntry) {
        if (compareEntry && entry.id === compareEntry.id && entry.type === compareEntry.type) {
            return compareEntry;
        }
        if (!compareEntry) {
            for (let i = 0; i < self.data.entries.length; i++) {
                let foundEntry = findEntry(entry, self.data.entries[i]);
                if (foundEntry) {
                    return foundEntry;
                }
            }
        }
        else if (compareEntry.entries) {
            for (let i = 0; i < compareEntry.entries.length; i++) {
                let foundEntry = findEntry(entry, compareEntry.entries[i]);
                if (foundEntry) {
                    return foundEntry;
                }
            }
        }

    }

    self.getIconClass = function (entry) {
        var result = '';
        if (entry.isFolder) {
            result = 'mdi-folder ';
        }

        switch (entry.type) {
            case "COMPANY":
                result += 'mdi-home-city mdi-icon-blue';
                break;
            case "USER":
                result += 'mdi-account mdi-icon-red';
                break;
            case "CONTRACT":
                result += 'mdi-gavel mdi-icon-dark-grey';
                break;
            case "CATALOG":
                result += 'mdi-book mdi-icon-green';
                break;
            case "CTT":
                result += 'mdi-numeric-1-box-outline mdi-icon-grey';
                break;
            case "CTU":
                result += 'mdi-numeric-2-box-outline mdi-icon-grey';
                break;
            case "PRJ":
                result += 'mdi-numeric-3-box-outline mdi-icon-grey';
                break;
            case "CTRLA":
                result += 'mdi-numeric-4-box-outline mdi-icon-grey';
                break;
            case "CTRLB":
                result += 'mdi-numeric-5-box-outline mdi-icon-grey';
                break;
            default:
                return "";
        }

        return result;
    }

    self.goToDetails = function (event, entry, open) {
        if (entry.isFolder) {
            self.toggle(event, entry, open);
        }
        else {
            switch (entry.type) {
                case "COMPANY":
                    $redirect.redirectTo(null, "/companydata/" + entry.comId);
                    break;
                case "USER":
                    $redirect.redirectTo(null, "/personaldata/" + entry.id);
                    break;
                case "CONTRACT":
                    $redirect.redirectTo(null, "/cscmain/" + entry.id);
                    break;
                case "CATALOG":
                    $redirect.redirectTo(null, "/vcatalogedit/" + entry.id);
                    break;
                case "CTT":
                    $redirect.redirectTo(null, "/editctu/" + entry.id);
                    break;
                case "CTU":
                    $redirect.redirectTo(null, "/editctt/" + entry.id);
                    break;
                case "PRJ":
                    $redirect.redirectTo(null, "/editprj/" + entry.id);
                    break;
                case "CTRLA":
                    $redirect.redirectTo(null, "/editctrla/" + entry.id);
                    break;
                case "CTRLB":
                    $redirect.redirectTo(null, "/editctrlb/" + entry.id);
                    break;
            }
        }
    };

    function chunk(arr, len) {
        var chunks = [],
            i = 0,
            n = arr.length;

        while (i < n) {
            chunks.push(arr.slice(i, i += len));
        }

        return chunks;
    }

    function applyItemList(items, data) {
        var chunks = chunk(items, 100);
        data.entries = chunks[0];

        var delay = 100;
        angular.forEach(chunks, function (value, index) {
            delay += 100;

            if (index > 0) {
                $timeout(function () {
                    data.entries = data.entries.concat(value);
                }, delay);
            }
        });
    }

    function getRootNodes() {
        var result = null;
        if (self.data) {
            result = {};
            angular.copy(self.data, result);
            delete result.entries;
        }
        self.requestInProgress = true;
        return dataGen.postAsForm(!result ? self : {}, result ? {data: result} : null, '/companyhierarchy/root').then(function (data) {
            if (result) {
                applyItemList(data.data.entries, self.data);
            }
            self.requestInProgress = false;
            self.selectedNode = {};
            self.breadcrumbs = [{comId: 0, label: 'Root', type: 'COMPANY'}];
        });
    }

    function getSubNodes(entry) {
        var result = null;
        if (self.data) {
            result = {};
            angular.copy(self.data, result);
            delete result.entries;
            result.selected = entry;
        }
        setSelectedNode(entry);

        self.requestInProgress = true;
        return dataGen.postAsForm({}, {data: result}, '/companyhierarchy/sub').then(function (data) {
            self.requestInProgress = false;
            return data;
        });
    }

    function setSelectedNode(selectedEntry) {
        if (!selectedEntry.isLeaf) {
            self.breadcrumbs = [{comId: 0, label: 'Root', type: 'COMPANY'}];

            for (let i = 0; i < self.data.entries.length; i++) {
                let entry = self.data.entries[i];
                if (entry.isOpen) {
                    let foundBreadCrumbWithEntry = buildBreadCrumb(entry, selectedEntry);
                    if (foundBreadCrumbWithEntry) {
                        angular.copy(foundBreadCrumbWithEntry, self.breadcrumbs);
                    }
                }
            }
        }
        $timeout(function () {
            if (self.breadcrumbs && self.breadcrumbs.length > 2) {
                let element = angular.element('#breadcrumb')[0];
                self.hasOverflow = element.scrollWidth > element.clientWidth;
                if (self.hasOverflow) {
                    self.breadcrumbs = [{id: 0, label: "...", overflowMarker: true}].concat(self.breadcrumbs);
                    cutOffOverflowingCrumbs();
                }
            }
        });
    }

    function cutOffOverflowingCrumbs()
    {
        self.breadcrumbs.splice(1, 1);
        $timeout(function () {
            let element = angular.element('#breadcrumb')[0];
            if (element.scrollWidth > element.clientWidth) {
                cutOffOverflowingCrumbs();
            }
        });
    }

    function buildBreadCrumb(rootNode, selectedEntry) {
        if (rootNode && rootNode.isOpen) {
            let breadCrumb = [{comId: 0, label: 'Root', type: 'COMPANY'}];
            breadCrumb.push(rootNode);
            if (rootNode.id === selectedEntry.id &&
                rootNode.type === selectedEntry.type) {
                return breadCrumb;
            }
            if (rootNode.entries) {
                for (let i = 0; i < rootNode.entries.length; i++) {
                    let foundSub = buildSubBreadCrumb(rootNode.entries[i], selectedEntry);
                    if (foundSub) {
                        breadCrumb = breadCrumb.concat(foundSub);
                        return breadCrumb;
                    }
                }
            }
        }
        return false;
    }

    function buildSubBreadCrumb(node, selectedEntry) {
        if (node.id === selectedEntry.id &&
            node.type === selectedEntry.type) {
            let toReturn = [];
            toReturn.push(node);
            return toReturn;
        }
        if (node && node.isOpen) {
            if (node.entries) {
                for (let i = 0; i < node.entries.length; i++) {
                    let foundSub = buildSubBreadCrumb(node.entries[i], selectedEntry);
                    if (foundSub)
                    {
                        let toReturn = [];
                        toReturn.push(node);
                        toReturn = toReturn.concat(foundSub);
                        return toReturn;
                    }
                }
            }
        }
        return null;
    }
}